import { motion } from "framer-motion";
import { AlertTriangle, CheckCircle2, Info, ShieldAlert, Wrench } from "lucide-react";
import { SEVERITY } from "@/lib/severity";

function icon(sev) {
  if (sev === "secure") return <CheckCircle2 size={20} strokeWidth={1.75} />;
  if (sev === "critical" || sev === "high") return <ShieldAlert size={20} strokeWidth={1.75} />;
  if (sev === "medium") return <AlertTriangle size={20} strokeWidth={1.75} />;
  return <Info size={20} strokeWidth={1.75} />;
}

const ORDER = { critical: 0, high: 1, medium: 2, low: 3, secure: 4 };

export function RiskList({ findings = [], explanations = {}, limit }) {
  const sorted = [...findings].sort((a, b) => (ORDER[a.severity] ?? 9) - (ORDER[b.severity] ?? 9));
  const items = limit ? sorted.slice(0, limit) : sorted;

  return (
    <div className="space-y-4" data-testid="risk-list">
      {items.map((f, i) => {
        const s = SEVERITY[f.severity] || SEVERITY.low;
        const ai = explanations[f.id];
        return (
          <motion.div
            key={f.id}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: Math.min(i * 0.05, 0.4) }}
            className="bg-[#0C1424] border rounded-lg p-5"
            style={{ borderColor: s.border }}
            data-testid={`risk-item-${f.id}`}
          >
            <div className="flex items-start gap-3">
              <div style={{ color: s.color }} className="mt-0.5">{icon(f.severity)}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 flex-wrap">
                  <h4 className="font-heading font-semibold text-white text-base">{f.title}</h4>
                  <span
                    className="text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full"
                    style={{ color: s.color, background: s.bg, border: `1px solid ${s.border}` }}
                  >
                    {s.label}
                  </span>
                  <span className="text-xs text-slate-500">{f.category}</span>
                </div>
                {ai ? (
                  <div className="mt-3 space-y-2 text-sm">
                    <p className="text-slate-300"><span className="text-cyanbrand font-semibold">What it is: </span>{ai.what}</p>
                    <p className="text-slate-300"><span className="text-cyanbrand font-semibold">Why it matters: </span>{ai.why}</p>
                    <p className="text-slate-300 flex gap-1.5"><Wrench size={16} className="text-cyanbrand shrink-0 mt-0.5" /><span><span className="text-cyanbrand font-semibold">How to fix: </span>{ai.fix}</span></p>
                  </div>
                ) : (
                  <p className="mt-2 text-sm text-slate-400">{f.detail}</p>
                )}
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
